import { emptyValidator, formValidator, nameValidator } from "../../validators";

const gsDivisionValidationStatus = {
  rgsName: {
    validators: [emptyValidator(), nameValidator()],
    name: "Grama Niladhari Division Name",
  },
  rgsStatus: {
    validators: [emptyValidator()],
    name: "Status",
  },
  rgsActive: {
    validators: [emptyValidator()],
    name: "Active",
  },
};

export const gsDivisionValidation = (gsDivision) => {
  return formValidator(gsDivision, gsDivisionValidationStatus);
};
